import React from 'react'
import Completed from './Completed'
import Confirmation from './Confirmation'
import MobileAuthentication from './MobileAuthentication'
import SignUp from './SignUp'

export { Completed, Confirmation, MobileAuthentication, SignUp }
